<div id="errorCoverageModal" class="modal fade" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p class="d-flex flex-column justify-content-center align-items-center">
					<img src="{{ warningPath }}" alt="Warning" />
					<span class="error-text mt-3">
						{{ "ERRORS.PLACE_NOT_COVERED" | translate }}
					</span>
				</p>
			</div>
		</div>
	</div>
</div>
